import type { ReactNode } from 'react';
import { Box } from '@mui/material';

import { Sidebar } from '../../Home/Sidebar';
import { SIDEBAR_SECTIONS } from '../../Home/sidebarSections';
import type { BenchmarkMonitoring } from '../../Benchmarks/types';
import type { DistrictStats } from '../districtStatsApi';
import type { LicenseRostering } from '../licensesApi';
import { DASH } from '../tokens';
import { DistrictStatsCard } from './DistrictStatsCard';
import { DistrictStatsComingSoonCard } from './DistrictStatsComingSoonCard';
import { LicenseRosteringBar } from './LicenseRosteringBar';
import { MonitoringRow } from './MonitoringRow';
import { GrowthTile } from '../../Growth/GrowthTile';
import { PAGE_MAX_WIDTH } from '../../../theme';
import { HEIGHT_BELOW_BARS } from '../../../core/bannerOffset';

// The dashboard without a usable Program Evaluation (none yet, or a stale one): the card fills in from whichever
// source is connected; when the stats request failed the card keeps the slot, checklist included, with the error
// and its Try again.
export function DistrictStatsPage({
  stats,
  licenseRostering,
  benchmarkMonitoring,
  checklist,
  onRetry,
}: {
  stats: DistrictStats | null;
  licenseRostering?: LicenseRostering | null;
  benchmarkMonitoring?: BenchmarkMonitoring | null;
  checklist?: ReactNode;
  onRetry?: () => void;
}) {
  return (
    <Box sx={{ display: 'flex', minHeight: HEIGHT_BELOW_BARS, bgcolor: DASH.surface }}>
      <Sidebar sections={SIDEBAR_SECTIONS} />
      <Box sx={{ flex: 1, padding: '32px 24px' }}>
        <Box sx={{ maxWidth: PAGE_MAX_WIDTH, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {licenseRostering ? (
            <LicenseRosteringBar licenses={licenseRostering.licenses} rostered={licenseRostering.rostered} />
          ) : null}
          {stats ? (
            <DistrictStatsCard stats={stats} checklist={checklist} />
          ) : (
            <DistrictStatsComingSoonCard checklist={checklist} onRetry={onRetry} />
          )}
          <GrowthTile />
          <MonitoringRow benchmarkMonitoring={benchmarkMonitoring} />
        </Box>
      </Box>
    </Box>
  );
}
